import React from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
import { Grid, Col, Row } from "react-bootstrap";
import { Authlayout, AuthContent, AuthDescription } from "../styles";
// import { companyIcon } from "helpers/dotenv";
import styled from "styled-components";
import { companyIcon } from "../../../../../helpers/dotenv";

const propTypes = {
  history: PropTypes.object,
  content: PropTypes.element,
  currentUser: PropTypes.object,
};

class AuthLayout extends React.Component {
  componentDidMount() {
    const { history, currentUser } = this.props;

    if (currentUser) {
      history.push("/");
    }
  }

  render() {
    const { content } = this.props;
    const { __ } = this.context;

    return (
      <Authlayout>
        <AuthContent>
          <Grid fluid className="">
            <Col md={12}>
              <TopIcon src="../images/topicon.png" />
              <TopArrow src="../images/toparrow.png" />
            </Col>
          </Grid>
          <Grid fluid className="bgRow">
            <Row>
              <Col md={6}>
                <AuthDescription>
                <StyledImage2 src={`../images/${companyIcon}`} />
                  {/* <img  src="../images/Logo.png"  /> */}
                  <StyledParagraph>
                    Connect,
                    <br />
                    Engage,
                    <br />
                    Enhance.
                  </StyledParagraph>
                  <StyledHr />
                    <StyledHeading>
                    Let's build together
                  </StyledHeading>

                  {/* <hr style={{ color: '#5E6FF9',width:"80%",borderTop:"3px solid #5E6FF9",paddingLeft:"30px" }} /> */}
                </AuthDescription>
                
              </Col>
              
              <StyledHr1 />
              
              {/* <Col md={1}></Col> */}
              
              <Col md={6} className="p-2">
              
                {content}
              </Col>
            </Row>
            {/* <Col md={1}></Col> */}
          </Grid>
          <StyledImage src="../images/bottom.png" />
        </AuthContent>
      </Authlayout>
    );
  }
}

AuthLayout.propTypes = propTypes;
AuthLayout.contextTypes = {
  __: PropTypes.func,
};
{
}
export default withRouter(AuthLayout);

const TopIcon = styled.img`
padding-top: 10px;
  width: 120px;
  transform: translateX(10px);
  /* @media (min-width: 360px),(max-width: 768px) {
    width: 100px;
    margin-top: 5px;
  } */
  @media (max-width: 768px) {
    padding-top: 10px;
    width: 80px;
    transform: translateX(-5px);
  }
`;

const TopArrow = styled.img`
  width: 100px;
  height: 100px;
  transform: translateY(80px);
  @media (max-width: 1024px) {
    width: 100px;
    height: 100px;
    margin-left: 30%;
    transform: translateY(20px);
  }
  /* margin-top: 10px; */
  /* transform: translateY(10px); */
  margin-left: 35%;
  @media (max-width: 768px) {
    width: 60px;
    padding-top: 25px;
    transform: translateX(100px);
  }

`;

const StyledHeading = styled.h2`
  color: #5e6ff9;
  font-weight: 400;
  font-size: 25px;
  padding-left: 20%;
  @media (max-width: 768px) {
    transform: translateX(-33px);
    font-size: 15px;
    line-height: -1;
  }
`;

const StyledParagraph = styled.p`
  color: black;
  padding-left: 20%;
  font-weight: 600;
  font-size: 5rem;
  line-height: 1.2em;
  word-spacing: 50px;
  @media (max-width: 768px) {
    transform: translateX(-30px);
    font-size: 40px;
    font-weight: 600;
    line-height: 1em;
    margin-bottom: -20px;
  }
`;

const StyledImage = styled.img`
  width: 18rem;
  bottom: 0;
  position: absolute;

  @media (max-width: 420px) {
    /* margin-top: 100px; */
    display: none;


    /* transform: translateY(60px);
    width: 12rem; */
  }

  @media (max-width: 1024px) {
    transform: translateY(200);
    width: 15rem;
  }
  
  @media (max-width: 390px) {
    /* position: absolute;
    bottom: -150px;
    width: 8rem; */
    display: none;


  }
`;

const StyledHr1 = styled.hr`
  color: black;
  margin-left: 65px;
  height: 70%;
  border-left: 2px solid black;
  @media (max-width: 768px) {
    display: none;

  }
`;

const StyledHr = styled.hr`
  color: #5e6ff9;
  margin-left:"33%";
  width: 32%;
  border-top: 2px solid #5e6ff9;
  margin-left: 20%;
  @media (max-width: 768px) {
    margin-left:33%;
    margin-bottom: -10px;
   
  }
  @media (max-width: 1024px) {
    margin-left: 33%;
    width: 40%;
  }
`;

const StyledImage2 = styled.img`
  width: 25rem;
  margin-left: 20%;

  @media (max-width: 768px) {
    width: 10rem;
    margin-left: 5%;
    
  }
`;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/components/AuthLayout.js